/**
 * The default formatter for the week number.
 */
export function formatWeekNumber(weekNumber) {
    return "" + weekNumber;
}
//# sourceMappingURL=formatWeekNumber.js.map